module.exports = __webpack_public_path__ + "img/文字@2x.56189c69.png";